import { Stack } from '@optimus-web/core';
import { ConfigurationTabs } from './configurationTabs/ConfigurationTabs';
import { ConfigurationTabItem } from './configurationTabs/ConfigurationTabItem';
import { DigitalKeyConfigurationOverviewContainer } from './overview/DigitalKeyConfigurationOverviewContainer';

export const DigitalKeyConfigurationContent = () => (
    <Stack vertical spacing="300">
        <ConfigurationTabs>
            {({ activeTabValue }) => {
                switch (activeTabValue) {
                    case ConfigurationTabItem.Overview: {
                        return <DigitalKeyConfigurationOverviewContainer />;
                    }
                    case ConfigurationTabItem.Rules: {
                        return <>Rules</>;
                    }
                    case ConfigurationTabItem.Design: {
                        return <>Design</>;
                    }
                }
            }}
        </ConfigurationTabs>
    </Stack>
);
